// FILECONTENT_START src/common/modules/theme/themeSlice.ts
import { ThemeOptions } from "@mui/material";
import { createSlice } from "@reduxjs/toolkit";

const initialState: ThemeOptions = {
  //...theme,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setThemeMode: (state: any, action) => {
      if (state.palette) {
        state.palette.mode = action.payload;
      } else {
        state.palette = { mode: action.payload };
      }
    },
  },
});

export const { setThemeMode } = themeSlice.actions;

export const selectTheme = (state: any) => state.theme;
export const selectThemeMode = (state: any) => state.theme.palette?.mode;

export default themeSlice.reducer;

// FILECONTENT_END src/common/modules/theme/themeSlice.ts